<template>
    <div
        id="videocall"
        :class="soundOnly && !isScreenSharing && !isCalling ? 'soundOnly' : ''"
        :style="{
            left: x ? `calc(${x}px)` : 0,
            top: y ? `calc(${y}px)` : 0,
        }"
    >
        <div v-if="!remoteVideoEnabled && !isCalling" class="vcthumbnail h-100 d-flex">
            <a-avatar
                :size="100"
                :username="getConversation().fullname"
                style="background-color: rgb(49 50 52) !important; color: white; font-size: 25px; margin: 80px auto"
                >{{ getConversation().fullname }}
            </a-avatar>
        </div>
        <div class="header">
            <button
                v-if="!isFullScreen"
                class="videocall-btn move-cursor"
                @mousedown="isMouseDown = true"
                @mouseup="isMouseDown = false"
            >
                <md-icon>open_with</md-icon>
            </button>
            <button
                v-if="isFullScreen && (!soundOnly || isScreenSharing)"
                class="videocall-btn"
                @click="closeFullScreen()"
            >
                <md-icon>close_fullscreen</md-icon>
            </button>
            <button
                v-if="!isFullScreen && (!soundOnly || isScreenSharing)"
                class="videocall-btn"
                @click="makeFullScreen()"
            >
                <md-icon>fullscreen</md-icon>
            </button>
        </div>
        <div v-if="isCalling" class="calling">
            <a-avatar :size="100" style="background-color: rgb(49 50 52) !important; color: white; font-size: 25px"
                >{{ getConversation().fullname.substr(0, 1).toUpperCase() }}
            </a-avatar>
            <strong class="p-3"> {{ getConversation().fullname }} Aranıyor .... </strong>
            <div class="callingToolbox">
                <md-button class="md-icon-button md-fab" @click.prevent="reject">
                    <md-icon style="color: white">call_end</md-icon>
                </md-button>
            </div>
        </div>
        <div v-show="remoteVideoEnabled" id="video_display" key="video_display"></div>
        <div
            v-if="!soundOnly"
            id="video_self"
            key="video_self"
            :style="selfVideoPositions[currentSelfPosition]"
            @dblclick="changeSelfPosition"
        ></div>
        <div v-if="isAnswered()" class="controlBox">
            <md-button class="md-icon-button md-primary play-sound-button" @click.prevent="askScreenShare">
                <md-icon>screen_share</md-icon>
            </md-button>
            <md-button
                v-if="!soundOnly"
                class="md-icon-button md-primary play-sound-button"
                @click.prevent="toggleVideoCam"
            >
                <md-icon>{{ videoEnabled ? "videocam" : "videocam_off" }}</md-icon>
            </md-button>
            <md-button class="md-icon-button md-primary play-sound-button" @click.prevent="toggleMic">
                <md-icon>{{ micEnabled ? "mic" : "mic_off" }}</md-icon>
            </md-button>
            <md-button class="md-icon-button md-primary play-sound-button" @click.prevent="cancelVideoCall">
                <md-icon style="color: red">cancel</md-icon>
            </md-button>
        </div>
    </div>
</template>

<script>
import { log2 } from "../utils/log2";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { getVideoCall } from "../webrtc/phoneSDK";
import { PHONE_UTILS } from "../utils/phone";
import { systemMessageStream } from "../utils/systemPubSub";
import { filter, first } from "rxjs/operators";
import { sendSocketMessage } from "../utils/socketStream";
import fscreen from "fscreen";

const log = log2("VideoCallScreen");
export default {
    name: "VideoCallScreen",
    components: {},

    data() {
        return {
            sub: null,
            callStartSound: new Audio("./static/media/videoCallSounds/call-start.ogg"),
            isMouseDown: false,
            x: 0,
            y: 0,
            isFullScreen: false,
            currentSelfPosition: 0,
            selfVideoPositions: [
                {
                    bottom: 0,
                    right: 0,
                },
                {
                    bottom: 0,
                    left: 0,
                },
                {
                    top: 0,
                    right: 0,
                },
                {
                    top: 0,
                    left: 0,
                },
            ],
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            videoCallMode: (state) => state.webrtc.videoCallMode,
            calling: (state) => state.webrtc.calling,
            answerTime: (state) => state.webrtc.answerTime,
            rejectTime: (state) => state.webrtc.rejectTime,
            dialingConversationId: (state) => state.webrtc.dialingConversationId,
            dialingVisitorId: (state) => state.webrtc.dialingVisitorId,
            user: (state) => state.auth.user,
            videoEnabled: (state) => state.webrtc.videoEnabled,
            micEnabled: (state) => state.webrtc.micEnabled,
            remoteVideoEnabled: (state) => state.webrtc.remoteVideoEnabled,
            soundOnly: (state) => state.webrtc.soundOnly,
            isScreenSharing: (state) => state.webrtc.isScreenSharing,
        }),
        ...mapGetters({
            chats: "chat/getMyActiveConversations",
            isCalling: "webrtc/isCalling",
        }),
    },
    methods: {
        ...mapActions({
            setVideoCallMode: "webrtc/setVideoCallMode",
            closeConnection: "webrtc/closeConnection",
            videoCallRejected: "webrtc/videoCallRejected",
            videoCallAnswered: "webrtc/videoCallAnswered",
            setSoundOnly: "webrtc/setSoundOnly",
            screenShare: "webrtc/screenShare",
        }),
        ...mapMutations({
            mutRemoteVideoEnabled: "webrtc/SET_REMOTE_VIDEO_ENABLED",
            mutRemoteMicEnabled: "webrtc/SET_REMOTE_MIC_ENABLED",
        }),
        makeFullScreen() {
            const elem = document.getElementById("videocall");
            log("is full screen supported ", { isSupported: fscreen.fullscreenEnabled });
            fscreen.requestFullscreen(elem);
        },
        closeFullScreen() {
            fscreen.exitFullscreen();
        },
        askScreenShare() {
            sendSocketMessage("user video-call-screen-share-request", {
                siteId: this.site._id,
                userId: this.user._id,
                visitorId: this.dialingVisitorId,
            });
        },
        reject() {
            const phone = PHONE_UTILS.getPhone();

            //phone.hangup(this.dialingVisitorId)
            sendSocketMessage("user video-call-close", {
                siteId: this.site._id,
                userId: this.user._id,
                visitorId: this.dialingVisitorId,
                conversationId: this.dialingConversationId,
                isSoundOnly: this.soundOnly,
            });
            if (phone) phone.camera.stop();
            this.closeConnection();
            this.setVideoCallMode({
                videoCallMode: false,
                conversationId: null,
                visitorId: null,
            });
        },
        toggleMic() {
            const phone = PHONE_UTILS.getPhone();
            phone.camera.toggleAudio();
        },
        toggleVideoCam() {
            const phone = PHONE_UTILS.getPhone();
            phone.camera.toggleVideo();
        },
        shareScreen() {},
        cancelVideoCall(signal = true) {
            log("cancelVideoCall", this.dialingVisitorId);
            const phone = PHONE_UTILS.getPhone();

            if (signal)
                sendSocketMessage("user video-call-close", {
                    siteId: this.site._id,
                    userId: this.user._id,
                    visitorId: this.dialingVisitorId,
                    conversationId: this.dialingConversationId,
                    isSoundOnly: this.soundOnly,
                });
            if (this.videoCallMode) {
                phone.camera.stop();
                if (signal) phone.hangup(this.dialingVisitorId);
            }
            this.closeConnection();
            this.setVideoCallMode({
                videoCallMode: false,
                conversationId: null,
                visitorId: null,
                soundOnly: false,
            });
        },
        waiting() {
            return this.videoCallMode && this.calling && !this.rejectTime && !this.answerTime;
        },
        isRejected() {
            return this.videoCallMode && this.calling && this.rejectTime;
        },
        isAnswered() {
            return this.videoCallMode && !this.calling && this.answerTime;
        },
        getConversation() {
            return this.chats.find((x) => x._id === this.dialingConversationId);
        },
        init() {
            log("dialingVisitorId changed", this.videoCallMode, this.dialingVisitorId);
            const phone = PHONE_UTILS.getPhone();
            window.px = phone;
            if (this.videoCallMode) {
                const video_out = document.getElementById("video_display");
                const video_self = document.getElementById("video_self");
                const vc = getVideoCall(this.dialingVisitorId);
                log("init", vc);
                const myVideo = phone.camera.video();
                if (myVideo && !this.soundOnly) {
                    log("camera received 1");
                    log("appending 1");
                    video_self.innerHTML = "";
                    video_self.appendChild(myVideo);
                } else if (!this.soundOnly) {
                    phone.camera((v) => {
                        log("camera received2", v);
                        video_self.innerHTML = "";
                        video_self.appendChild(v);
                    });
                }
                log("remote connected 1", vc);
                if (!!vc) {
                    vc.connected((session) => {
                        log("remote connected 1.5", vc);
                        log("remote connected 2 ", session.video);
                        this.mutRemoteVideoEnabled(true);
                        video_out.innerHTML = "";
                        video_out.appendChild(session.video);
                    });
                }
            }
        },
        changeSelfPosition() {
            if (this.currentSelfPosition < 3) {
                this.currentSelfPosition += 1;
            } else {
                this.currentSelfPosition = 0;
            }
        },
    },

    watch: {
        videoCallMode(vcMode) {
            this.init();
        },
    },
    mounted() {
        log("mounted video call mode", this.videoCallMode);
        log("mounted");
        if (this.videoCallMode) this.init();
        this.timerId = setTimeout(() => {
            if (this.isCalling) {
                this.reject();
            }
        }, 1000 * 60 * 2);
        this.sub = systemMessageStream
            .pipe(
                filter((x) => x.type === "vc_answered"),
                first()
            )
            .subscribe((x) => {
                log("vc_answered received");
                this.init();
            });
        this.rejectSub = systemMessageStream
            .pipe(
                filter((x) => x.type === "vc_rejected"),
                first()
            )
            .subscribe((x) => {
                log("vc_rejected received");
                this.reject();
            });
        this.cancelSub = systemMessageStream
            .pipe(
                filter((x) => x.type === "vc_ended"),
                first()
            )
            .subscribe((x) => {
                log("vc_ended received", x);
                const signal = !!x.payload.signal;
                this.cancelVideoCall(signal);
            });
        this.isConnected = systemMessageStream
            .pipe(
                filter((x) => x.type === "videocall-success"),
                first()
            )
            .subscribe((x) => {
                this.callStartSound.play();
            });
        window.addEventListener("mousemove", (ev) => {
            if (!this.isMouseDown) return;
            this.x = ev.clientX - 32;
            this.y = ev.clientY - 32;
        });
        if (fscreen.fullscreenEnabled) {
            fscreen.addEventListener("fullscreenchange", () => {
                if (fscreen.fullscreenElement !== null) {
                    log("Entered fullscreen mode");
                    this.isFullScreen = true;
                } else {
                    log("Exited fullscreen mode");
                    this.isFullScreen = false;
                }
            });
        }
    },

    updated() {
        log("updated");
    },
    beforeDestroy() {
        if (this.sub) this.sub.unsubscribe();
        if (this.rejectSub) this.rejectSub.unsubscribe();
        if (this.cancelSub) this.cancelSub.unsubscribe();
        if (this.isConnected) this.isConnected.unsubscribe();
        clearInterval(this.timerId);
    },
    destroyed() {
        log("destroyed");
    },
};
</script>

<style lang="scss">
.soundOnly {
    width: 20% !important;
    height: 55px !important;
}

#videocall {
    position: fixed;
    z-index: 9999999;
    top: 10%;
    right: 30px;
    width: 40%;
    overflow: hidden;
    height: 40%;
    background: #f8f9fa;
    border-radius: 24px;
    box-shadow: 0 0 3px #00000080;

    .header {
        position: absolute;
        left: 20px;
        top: 20px;

        z-index: 9999;

        .videocall-btn {
            background-color: transparent;
            border: none;

            &:hover {
                border-radius: 40%;
                background-color: rgba(0, 0, 0, 0.3);
            }
        }

        .move-cursor {
            cursor: move;
        }
    }

    .calling {
        margin: 0 auto;
        //padding-top: 30%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        height: 100%;

        .callingToolbox {
            display: flex;
            justify-content: center;

            button {
                background: red !important;
            }
        }
    }

    #video_display {
        width: 100%;
        height: 100%;

        video {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    #video_self {
        position: absolute;
        width: 30%;
        border-radius: 24px;
        box-shadow: 0 0 3px #00000080;
        overflow: hidden;
        cursor: pointer;

        video {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .controlBox {
        /* border: 1px solid red; */
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: none;
        position: absolute;
        bottom: 0;
        width: 100%;
    }
}
</style>
